import React from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../context/AppContext";

/** The guest's table number. `square` for the menu header, `pill` inline elsewhere. */
const TableBadge = ({ variant = "pill" }) => {
  const { t } = useTranslation();
  const { tableLabel } = useAppContext();
  // Until the guest entered the table code the server has no table to show.
  if (!tableLabel) return null;
  if (variant === "square") {
    return (
      <div className="w-14 h-14 flex-none rounded-md bg-primary-50 text-primary flex flex-col items-center justify-center">
        <span className="text-[11px] leading-[14px] font-medium">{t("Table")}</span>
        <span className="text-lg leading-[22px] font-bold">{tableLabel}</span>
      </div>
    );
  }
  return (
    <span className="h-8 px-3 rounded-sm bg-primary-50 text-primary text-xs font-bold flex items-center whitespace-nowrap">
      {t("Table")} {tableLabel}
    </span>
  );
};

export default TableBadge;
